import { removeToken } from "@/util/auth";
import { logout } from "@/api/profile";

export default [
  {
    name: "APP_LOGIN_SUCCESS",
    callback: function() {
      this.$router.push({ path: "dashboard" });
    }
  },
  {
    name: "APP_LOGOUT",
    callback: function() {
      logout()
        .then(() => {
          removeToken();
          this.snackbar = {
            show: true,
            color: "green",
            text: "Logout successfully."
          };
          this.$router.replace({ path: "/login" });
        })
        .catch(error => {
          console.log(error);
          removeToken();
          this.snackbar = {
            show: true,
            color: "green",
            text: "Logout successfully."
          };
          this.$router.replace({ path: "/login" });
        });
    }
  },
  {
    name: "APP_PAGE_LOADED",
    callback: function() {}
  },
  {
    name: "APP_AUTH_FAILED",
    callback: function() {
      removeToken();
      this.snackbar = {
        show: true,
        y: "top",
        color: "red",
        text: "Token is invalid."
      };
      this.$router.push("/login");
    }
  },
  {
    name: "APP_BAD_REQUEST",
    // @error api response data
    callback: function(msg) {
      this.$message.error(msg);
    }
  },
  {
    name: "APP_ACCESS_DENIED",
    // @error api response data
    callback: function(msg) {
      this.$message.error(msg);
      this.$router.push("/forbidden");
    }
  },
  {
    name: "APP_RESOURCE_DELETED",
    // @error api response data
    callback: function(msg) {
      this.$message.success(msg);
    }
  },
  {
    name: "APP_RESOURCE_UPDATED",
    // @error api response data
    callback: function(msg) {
      this.$message.success(msg);
    }
  },
  {
    name: "SHOW_LOADING",
    callback: function() {
      this.showLoading = true;
    }
  },
  {
    name: "HIDE_LOADING",
    callback: function() {
      this.showLoading = false;
    }
  }
];
